import type { CustomChartTextSize } from '@/entities/dashboards';

/**
 * Классы общего размера текста результата: маленький — 12 пт, средний — 16 пт, большой — 20 пт.
 * Парная запись — классы размера части текста `.ql-size-*` в общей теме: править обе.
 */
const CHART_TEXT_SIZE_CLASS: Record<CustomChartTextSize, string> = {
  small: 'text-result-sm',
  medium: 'text-result-md',
  large: 'text-result-lg',
};

/** Класс размера текста результата; размер не выбран — `undefined`, и текст показан размером по умолчанию. */
export const chartTextSizeClass = (textSize: CustomChartTextSize | null | undefined): string | undefined =>
  textSize ? CHART_TEXT_SIZE_CLASS[textSize] : undefined;
